import { AuthService } from '@teko/auth';
import { NotificationService } from '@teko/notification';
import {
  JUST_LOGGED_IN_KEY,
  LOCAL_STORAGE_ALLOWED_PRIVACY_POLICY,
  LOCAL_STORAGE_SUBMIT_PRIVACY_POLICIES,
  userSelectedConstants,
} from '../constants';
import { removeUserSelectedInfo } from '../helpers/env';
import { unregisterUNS } from '../modules/notification/helper';

const { TERMINAL, TERMINAL_ID, TERMINAL_NAME, TERMINALS, USER_LOCATION } =
  userSelectedConstants;

// Set right before redirecting to IAM for login, so that on the redirect-back
// load we can tell it apart from a plain page reload/session restore.
export const markJustLoggedIn = () => {
  if (typeof window === 'undefined') return;
  sessionStorage.setItem(JUST_LOGGED_IN_KEY, '1');
};

// Read-only: returns true only for the load right after a fresh login
export const peekJustLoggedInFlag = (): boolean => {
  if (typeof window === 'undefined') return false;
  return sessionStorage.getItem(JUST_LOGGED_IN_KEY) === '1';
};

export const clearJustLoggedInFlag = () => {
  if (typeof window === 'undefined') return;
  sessionStorage.removeItem(JUST_LOGGED_IN_KEY);
};

export const clearStorageOnSignout = (epicOmni1825?: boolean) => {
  [
    LOCAL_STORAGE_SUBMIT_PRIVACY_POLICIES,
    LOCAL_STORAGE_ALLOWED_PRIVACY_POLICY,
    ...(!!epicOmni1825
      ? [TERMINAL, TERMINAL_ID, TERMINAL_NAME, TERMINALS, USER_LOCATION]
      : []),
  ].forEach((lsKey) => {
    const actualKey = [TERMINALS, USER_LOCATION].includes(lsKey)
      ? lsKey.toUpperCase()
      : lsKey;
    localStorage.removeItem(actualKey);
    localStorage.removeItem(`${actualKey}_mobile`);
  });
};

export const clearCookiesOnLogout = () => {
  [TERMINAL, TERMINAL_ID, TERMINAL_NAME].forEach((lsKey) => {
    removeUserSelectedInfo(lsKey);
    removeUserSelectedInfo(lsKey, true); //key on mobile view
  });
};

export const onSignOut = async (
  authService: AuthService,
  notificationService: NotificationService,
  notificationAppId: string,
  redirectUrl?: string,
  epicOmni1825?: boolean,
): Promise<void> => {
  unregisterUNS(notificationService, notificationAppId);
  authService.logout(redirectUrl);
  clearStorageOnSignout(epicOmni1825);
  if (!!epicOmni1825) {
    clearCookiesOnLogout();
  }
};
